<section class="pix-data">
  <p class="h5">Pagamento via PIX</p>
  @if (showInternationalHint) {
    <p class="small mb-3" [class.text-muted]="canGenerateQr" [class.alert]="!canGenerateQr" [class.alert-warning]="!canGenerateQr">
      O QR Code PIX só é gerado se o cliente tiver passaporte cadastrado. Sem passaporte, a geração fica bloqueada — use o
      link de cartão.
    </p>
  }
  <div class="container-pix">
    @if (pixData) {
      @if (detailsSuppressed) {
        <p class="text-muted mb-0" role="status">
          Cobrança ativa. Abra o painel de cobrança para ver o QR, copia e cola e o status do pagamento.
        </p>
      } @else {
        <div class="pix-info mb-3">
          <div class="d-flex justify-content-between align-items-center">
            <span class="text-muted">Valor:</span>
            <strong class="h4">{{ pixData.amount | currency: "BRL" }}</strong>
          </div>
        </div>

        <div class="d-flex justify-content-center align-items-center mb-3">
          <qr-code [value]="pixData.qr_code" size="300" errorCorrectionLevel="M" />
        </div>

        <div class="status-payment mb-3">
          <div
            class="alert"
            [ngClass]="{
              'alert-info': statusPaymentPix === 'AGUARDANDO PAGAMENTO',
              'alert-success': statusPaymentPix === 'PAGO',
              'alert-danger': statusPaymentPix === 'FALHOU',
            }">
            <span>{{ statusPaymentPix }}</span>
            <small class="d-block mt-2">
              <i
                class="fas fa-wifi me-1"
                [class.text-success]="isWebSocketConnected"
                [class.text-muted]="!isWebSocketConnected"></i>
              {{
                isWebSocketConnected ? "Conectado - Aguardando confirmação em tempo real" : "Verificando periodicamente"
              }}
            </small>
          </div>
        </div>

        <div class="mb-3">
          <label class="form-label" for="sellerPixCode">PIX Copia e Cola</label>
          <input id="sellerPixCode" type="text" class="form-control" [value]="pixData.qr_code" readonly />
        </div>
      }
    }

    <div class="actions">
      @if (pixData && !detailsSuppressed) {
        <app-button (btnClick)="copyPixKey()">
          <i class="fas fa-copy me-2"></i>
          Copiar Código PIX
        </app-button>
      } @else if (!pixData) {
        <app-button
          (btnClick)="generateChargeClick.emit()"
          [disabled]="loading || !canGenerateQr"
          styleType="success">
          {{ loading ? "Gerando cobrança..." : "Gerar Cobrança PIX" }}
        </app-button>
      }
    </div>
  </div>
</section>
